import ENV_VARS from '../utils/envVars';

export const GET_METRICS_SUCCESS = 'GET_METRICS_SUCCESS';
export const GET_METRICS_FAILURE = 'GET_METRICS_FAILURE';

export function getMetricsApi() {
  const config = {
    baseURL: ENV_VARS.BASE_URL,
    url: '/metrics',
    method: 'GET',
    params: {},
  };

  return {
    type: 'API_CALL',
    config,
    auth: true,
    spinner: true,
    successAction: GET_METRICS_SUCCESS,
    failureAction: GET_METRICS_FAILURE,
  };
}
